import backend from '@common/backend';

const BASE = '/main-goals';

export const getMainGoal = () => backend.get(`${BASE}`, {});

export const postMainGoal = async (data: any) => backend.post(`${BASE}`, data);

export const saveMainGoal = async (id: number, data: any) => backend
	.patch(`${BASE}/${id}`, data);
